/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ConversationIndexResponse } from '../types/ConversationIndex'

/**
 * GET /ai/conversations
 * @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::index
 */
export async function conversationIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ConversationIndexResponse>> {
	return axiosInstance.get('/ai/conversations', config)
}
